





























































































import { Mixins, Component } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

import * as I from '@/interfaces';
import * as U from '@/utils';
import * as E from '@/enums';

import AxAPI from '@/api';

type Group = I.AxZone;
type Item = I.GroupSingle;

type GroupListPanel = I.AxGroupListPanel<Group, Item>;
type PageInfo = I.GroupPageInfo;

type DataItem = U.DataItem<unknown, State>;
type DataStore = U.DataStore<unknown, never>;

type UpdateItemParam = I.GroupUpdateReq;

const DataStore = U.DataStore;

class State {
  name: string;
  code: number;
  zoneCode: number;
  zoneName: string;
  etc: string;
  listAllDoor: I.DoorData[];
  listDoor: I.DoorData[];
  itemStatus: E.ItemStatus;

  constructor() {
    this.name = '';
    this.code = 0;
    this.zoneName = '';
    this.zoneCode = 0;
    this.etc = '';
    this.listAllDoor = [];
    this.listDoor = [];
    this.itemStatus = E.ItemStatus.None;
  }
}

abstract class BaseClass extends Mixins(AxPage) {
  API!: AxAPI;
  panel!: GroupListPanel;
  pageInfo!: PageInfo;
  dataItem!: DataItem;
}

interface BaseInterface extends BaseClass {}

@Component
class ApiHandler extends BaseClass {
  async getPageInfo() {
    const result = await this.API.call.group.get();
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async updateItem(item: UpdateItemParam) {
    const result = await this.API.call.group.groupUpdate(item);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }
}

@Component
class DataItemHandler extends BaseClass {
  dataItems: DataItem[] = [
    {
      name: '출입문 그룹 데이터',
      store: {} as DataStore,
      search: '',
      description: [],
      state: new State()
    }
  ];

  get dataItem() {
    return this.dataItems[0];
  }
}

@Component
class GroupPanelHandler extends BaseClass {
  onListGroupChanged(group?: Group) {
    if (!this.pageInfo || !group) return;
    if (this.panel.items) {
      this.panel.items = this.pageInfo.listGroup.filter(x => x.zoneCode === group.code);
    }
  }

  onListItemChanged(item?: Item) {
    if (item) {
      this.dataItem.state.zoneCode = item.zoneCode;
      this.dataItem.state.code = item.code;
      this.dataItem.state.name = item.name;
      this.dataItem.state.listAllDoor = this.pageInfo.listDoor.filter(
        x => x.zoneCode === item.zoneCode
      );
      this.dataItem.state.listDoor = JSON.parse(JSON.stringify(item.listDoor));
      this.dataItem.state.etc = item.etc;
      this.dataItem.state.itemStatus = E.ItemStatus.Update;
    } else {
      this.dataItem.state = new State();
    }
  }

  onListAddClicked(group: Group) {
    this.dataItem.state = new State();
    this.dataItem.state.zoneCode = group.code;
    this.dataItem.state.zoneName = group.name;
    this.dataItem.state.listAllDoor = this.pageInfo.listDoor.filter(x => x.zoneCode === group.code);
    this.dataItem.state.itemStatus = E.ItemStatus.New;
  }
}

@Component
class BaseData extends Mixins(AxPage) implements BaseInterface {
  dataItem!: DataItem;

  panel: GroupListPanel = {
    groups: [],
    items: [],
    group: -1,
    item: -1
  };

  pageInfo = {} as PageInfo;
}

const Handlers = Mixins(ApiHandler, DataItemHandler, GroupPanelHandler);

@Component
export default class DoorGroup extends Mixins(BaseData, Handlers) {
  async prepare() {
    const pageInfo = await this.getPageInfo();

    if (pageInfo) {
      this.pageInfo = pageInfo;
      this.panel.groups = this.getZoneList();
    }
  }

  async onSaveClicked() {
    const { itemStatus } = this.dataItem.state;
    if (itemStatus === E.ItemStatus.None) return;

    const updateFlag =
      itemStatus === E.ItemStatus.New ? E.EUpdateFlag.Insert : E.EUpdateFlag.Update;

    const { code, name, etc, zoneCode, listDoor } = this.dataItem.state;

    if (name === '') {
      await this.showErrorModal('오류', '이름을 입력 해주세요.');
      return;
    } else if (listDoor.length === 0) {
      await this.showErrorModal('오류', '장비를 선택 해주세요.');
      return;
    }

    const title = '확인';
    const message =
      itemStatus === E.ItemStatus.New
        ? '입력한 아이템을 추가할까요?'
        : '선택한 아이템을 수정할까요?';
    const buttons = ['네', '아니오'];

    const confirm = await this.showConfirmModal(title, message, buttons);
    if (confirm !== 0) return;

    this.setLoading(true);
    const result = await this.updateItem({ code, name, etc, zoneCode, listDoor, updateFlag });

    this.setLoading(false);
    if (!result) return;

    this.onUpdated(result, updateFlag);
  }

  async onDeleteClicked() {
    const { code, name, etc, zoneCode, listDoor, itemStatus } = this.dataItem.state;

    if (itemStatus === E.ItemStatus.None) return;

    const updateFlag = E.EUpdateFlag.Delete;

    const confirm = await this.showConfirmModal('확인', '선택된 아이템을 삭제할까요?', [
      '네',
      '아니오'
    ]);
    if (confirm !== 0) return;

    this.setLoading(true);
    const result = await this.updateItem({ code, name, etc, zoneCode, listDoor, updateFlag });

    this.setLoading(false);
    if (!result) return;

    this.onUpdated(result, E.EUpdateFlag.Delete);
  }

  async onUpdated(result: Item, updateFlag: E.EUpdateFlag) {
    if (!this.pageInfo) return;
    const prevGroup = this.panel.group;
    this.panel.groups = [];
    this.panel.items = [];

    await this.prepare();
    await this.$nextTick();

    this.panel.group = prevGroup;

    if (updateFlag !== E.EUpdateFlag.Delete) {
      this.panel.item = this.panel.items.findIndex(x => x.code === result.code);
    }

    if (updateFlag === E.EUpdateFlag.Insert) {
      const zones: I.ZoneDetail[] = JSON.parse(JSON.stringify(this.pageInfo.listGroup));
      const latest = zones.sort((a, b) => b.code - a.code)?.[0];
      console.log(latest);
      if (latest) {
        const targetIndex = this.panel.items.findIndex(x => x.code === latest.code);
        this.panel.item = targetIndex;
      }
      this.dataItem.state.itemStatus = E.ItemStatus.Update;
      await this.showErrorModal('알림', '추가되었습니다');
    } else if (updateFlag === E.EUpdateFlag.Update) {
      await this.showErrorModal('알림', '수정되었습니다');
    } else if (updateFlag === E.EUpdateFlag.Delete) {
      this.dataItem.state = new State();
      this.panel.item = -1;
      await this.showErrorModal('알림', '삭제되었습니다');
    }
  }

  async onClearClicked() {
    const confirm = await this.showConfirmModal('확인', '입력중인 내용을 취소할까요?', [
      '네',
      '아니오'
    ]);

    if (confirm === 0) {
      this.dataItem.state = new State();
    }
  }
}
